import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';

import DateTimePicker from './DateTimePicker';

// File is created during build phase and placed in dist directory
// eslint-disable-next-line import/no-unresolved
import './DateTimePicker.css';

export default DateTimePicker;



// WEBPACK FOOTER //
// ./src/app/components/react-datetime-picker/entry.js